<template>
  <v-container class="section mt-12 pb-12" id="products">
    <v-divider class="mb-12" />

    <!-- The section heading -->
    <div
      class="font-weight-bold bluegray--text text-h4 text-center"
      v-vue-aos.once="{ animationClass: 'fadeIn slow animated' }"
    >
      A <span class="primary--text">Complete</span> Influencer Marketing Platform
    </div>

    <!-- The subtitle -->
    <div
      class="section__subtitle text-center mt-4"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      Check out features and services available inside our product's dashboard
    </div>

    <!-- Show the grid -->
    <v-row class="mt-6">
      <!-- Multiple columns -->
      <v-col
        v-for="(item, index) in items"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        v-vue-aos.once="{ animationClass: 'fadeIn slow animated' }"
      >
        <v-card
          outlined
          :to="item.to"
        >
          <v-hover v-slot="{ hover }">
            <v-card-text>
              <!-- Show the icon -->
              <v-icon :color="hover ? 'primary' : 'bluegray'">
                {{ item.icon }}
              </v-icon>

              <div
                class="font-weight-bold mt-3"
                :class="{ 'primary--text': hover, 'bluegray--text': !hover }"
              >
                {{ item.title }}
              </div>

              <div class="mt-3">
                {{ item.text }}
              </div>
            </v-card-text>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: "Index",

  // Local data variables
  data: () => ({
    items: [
      {
        title: "Influencer Discovery",
        text: "Search through a massive database of over 244+ million profiles using our filters.",
        icon: "person_search",
        to: {
          name: "Product/InfluencerDiscovery"
        }
      },

      {
        title: "Influencer Insight",
        text: "Read and analyze an influencers profile insights about their audience and most performing posts.",
        icon: "insights",
        to: {
          name: "Product/InfluencerInsight"
        }
      },

      {
        title: "Audience Overlap",
        text: "Compare two or more influencers to find out how much of common audience they share.",
        icon: "picture_in_picture",
        to: {
          name: "Product/AudienceOverlap"
        }
      },

      {
        title: "Tie Breaker",
        text: "Run a side-by-side comparison between multiple influencers to grasp a better view.",
        icon: "compare",
        to: {
          name: "Product/TieBreaker"
        }
      },

      {
        title: "Paid Collaborations",
        text: "Using our set of a dozen filters, find out all the competing posts in the same category.",
        icon: "query_stats",
        to: {
          name: "Product/PaidCollaborations"
        }
      },

      {
        title: "CRM",
        text: "Run and manage your campaigns from A-Z using our set of features.",
        icon: "support_agent",
        to: {
          name: "Product/CRM"
        }
      },
    ]
  })
}
</script>
